<template>
  <component
    :is="navType === 1 ? 'yxtf-checkbox' : 'yxt-checkbox'"
    ref="checkbox"
    :class="className"
    :disabled="disabled"
    :label="label"
  >
    <slot />
  </component>
</template>
<script>
export default {
  props: {
    label: {
      type: [String, Boolean, Object, Number]
    },
    color: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    navType() {
      return this.$route.meta.navCode;
    },
    className() {
      if (!this.color) {
        return '';
      }
      const strColor = this.color.split('#')[1];
      if (strColor) {
        return `colorful-checkbox--${strColor.toLocaleLowerCase()}`;
      } else {
        return '';
      }
    }
  }
};
</script>
<style lang="scss">
  /* stylelint-disable */
  $checkboxColor: #a4acc8, #1fc7c8, #4570ff, #9661bc, #00aaff, #ccd0df, #acb3cb, #2fd8d9, #5f4cff,
  // new colors 20220321
   #7f8ab3, #4943ff, #ff6100, #fe4485, #02aa5a, #7843ff, #ff003f, #2b9dbd, #0096ff, #e59425;

  @function hexToRGBString($hexColor, $opacity: 0.3) {
    @return rgba(red($hexColor),green($hexColor),blue($hexColor), $opacity);
  }
  @each $c in $checkboxColor {
    .colorful-checkbox--#{str-slice($c + '', 2)} {
      &.is-disabled {
        .yxtf-checkbox__label,.yxt-checkbox__label {
          color: #8c8c8c;
        }
      }
      .yxt-checkbox__inner, .yxtf-checkbox__inner {
        background-color: hexToRGBString($c);
        border-color: $c;
      }

      .yxt-checkbox__input.is-disabled .yxt-checkbox__inner, .yxtf-checkbox__input.is-disabled .yxtf-checkbox__inner {
        opacity: 0.3;
        background-color: hexToRGBString($c, 0.15);
        border-color: $c;
      }
      .yxt-checkbox__input.is-checked .yxt-checkbox__inner, .yxt-checkbox__input.is-checked-alone .yxt-checkbox__inner, .yxtf-checkbox__input.is-checked .yxtf-checkbox__inner, .yxtf-checkbox__input.is-checked-alone .yxtf-checkbox__inner {
        background-color: $c;
        border-color: $c;
      }
      .yxt-checkbox__input.is-disabled.is-checked .yxt-checkbox__inner::after, .yxt-checkbox__input.is-disabled.is-checked-alone .yxt-checkbox__inner::after, .yxtf-checkbox__input.is-disabled.is-checked .yxtf-checkbox__inner::after, .yxtf-checkbox__input.is-disabled.is-checked-alone .yxtf-checkbox__inner::after {
        border-color: #fff;
      }
      &.yxt-checkbox:not(.is-disabled):not(.is-disabled-lock):hover .yxt-checkbox__inner, &.yxtf-checkbox:not(.is-disabled):not(.is-disabled-lock):hover .yxtf-checkbox__inner {
        border-color: $c;
      }
    }
  }
</style>
